<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      {{ "Edit Serial Number" | translate | async }}<!--  {{ title }} -->
    </span>
    <!-- <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i> -->
  </div>
  <div class="ttmodal__body">

    <div>
        <mat-form-field class="input">
          <input class="titleInput" matInput placeholder="{{'Serial Number' | translate | async}}" type="text" [(ngModel)]="SerialNumber" 
       required>
        </mat-form-field>
    </div>

  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()"> {{ 'Cancel' | translate | async }}</button>
    <button mat-raised-button color="warn"   (click)="UpdateSerialNumber()"><span class="material-icons button__icon">check</span><span class="button__text">{{ 'Edit' | translate | async }} </span></button>
  </div>
</div>